$(document).ready(function () {
    const subToggle = $('.nav-sub-toggle');
    const subNav = $('.sub-nav');
    const menuClose = $('.menu-close');
    const siteHeader = $('.site-header');
    const searchLink = $('.search-link');
    const headerSearch = $('.header-search');
    const headerContainer = $('.header-container');
    
    // Toggle .show class on .search-link and .header-search
    searchLink.on('click', function(e) {
        e.preventDefault();

        // Check if the search overlay is already open
        if (searchLink.hasClass('show')) {
            searchLink.removeClass('show').attr('aria-expanded', 'false');
            headerSearch.removeClass('show').attr('aria-hidden', 'true');
            siteHeader.removeClass('overlay-white has-overlay');
        } else {
            searchLink.addClass('show').attr('aria-expanded', 'true');
            headerSearch.addClass('show').attr('aria-hidden', 'false');

            // Ensure only the search overlay (white) is applied
            siteHeader.removeClass('overlay-gray').addClass('overlay-white');

            setTimeout(function() {
                headerSearch.find('.search-field').focus();
            }, 100);
        }
    });

    // Prevent search overlay from closing when clicking inside the .search-block
    headerSearch.on('click', function(e) {
        e.stopPropagation();
    });

    // Ensure sub-nav is hidden by default on mobile
    if (window.innerWidth < 992) {
        subNav.hide();
    }

    // Dropdowns with accordion behavior on mobile (below 992px)
    subToggle.on('click', function (e) {
        e.preventDefault();
        var $currentDropdown = $(this).closest('.nav-item');
        var isExpanded = $currentDropdown.hasClass('show');

        if (window.innerWidth < 992) {
            $('.sub-toggle').not(this).attr('aria-expanded', 'false').removeClass('show');
            $('.sub-nav').not($currentDropdown.find('.sub-nav')).slideUp(300).removeClass('show');
            menuClose.removeClass('show');

            // Toggle the current dropdown
            if (isExpanded) {
                $currentDropdown.find('.sub-nav').slideUp(300).removeClass('show');
                $currentDropdown.removeClass('show');
                $(this).attr('aria-expanded', 'false').removeClass('show');
            } else {
                $currentDropdown.find('.sub-nav').slideDown(300).addClass('show');
                $currentDropdown.addClass('show');
                $(this).attr('aria-expanded', 'true').addClass('show');
                menuClose.addClass('show');
            }
        } else {
            // Desktop behavior - toggle the dropdown, remove .show from others
            $('.nav-item').not($currentDropdown).removeClass('show');
            subToggle.not(this).attr('aria-expanded', 'false').removeClass('show');
            $('.sub-nav').not($currentDropdown.find('.sub-nav')).removeClass('show').css('display', '');
            menuClose.removeClass('show');

            if (isExpanded) {
                $currentDropdown.removeClass('show');
                $(this).attr('aria-expanded', 'false').removeClass('show');
                $currentDropdown.find('.sub-nav').removeClass('show').css('display', '');
            } else {
                $currentDropdown.addClass('show');
                $(this).attr('aria-expanded', 'true').addClass('show');
                $currentDropdown.find('.sub-nav').addClass('show').css('display', '');
                menuClose.addClass('show');
            }
        }

        // Toggle body class based on open dropdowns
        if ($('.nav-item.show').length > 0) {
            // Ensure the dropdown overlay (gray) is applied
            siteHeader.removeClass('overlay-white').addClass('overlay-gray');
        } else {
            siteHeader.removeClass('overlay-gray');
            menuClose.removeClass('show');
        }
    });

    // Handle clicks outside the dropdown to close
    $(document).on('click', function (e) {
        var $dropdown = $('.nav-item');

        if (!$dropdown.is(e.target) && $dropdown.has(e.target).length === 0) {
            $dropdown.removeClass('show');
            subToggle.attr('aria-expanded', 'false').removeClass('show');
            menuClose.removeClass('show');

            if (window.innerWidth < 992) {
                subNav.slideUp(300).removeClass('show');
            } else {
                subNav.removeClass('show').css('display', '');
            }
            siteHeader.removeClass('overlay-gray');
        }
    });

    // Toggle collapse on submenu and #primaryNavigation
    $('#navbarToggle').on('click', function(event) {
        var expanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !expanded);

        if ($('#primaryNavigation').hasClass('show')) {
            $('#primaryNavigation').removeClass('show');
            siteHeader.removeClass('overlay-gray');
            menuClose.removeClass('show');
            headerContainer.removeClass('menu-expanded');
        } else {
            $('#primaryNavigation').addClass('show');
            siteHeader.addClass('overlay-gray');
            menuClose.addClass('show');
            headerContainer.addClass('menu-expanded');
        }

        event.preventDefault();
    });

    // Handle window resize
    $(window).on('resize', function() {
        if (window.innerWidth >= 992) {
            $('.sub-nav').show().removeClass('show').css('display', '');
            $('.nav-item').removeClass('show');
            subToggle.attr('aria-expanded', 'false').removeClass('show');
            siteHeader.removeClass('overlay-gray');
            menuClose.removeClass('show');
            headerContainer.removeClass('menu-expanded');
        } else {
            $('.sub-nav').hide().removeClass('show');
        }
    }).trigger('resize');


    $(document).on('keydown', function(e) {
        // Check if ESC key (27) or Enter key (13) when menu-close is shown
        if (e.keyCode === 27 || (e.keyCode === 13 && menuClose.hasClass('show'))) {
            // Close search if it's open
            if (searchLink.hasClass('show')) {
                searchLink.removeClass('show').attr('aria-expanded', 'false');
                headerSearch.removeClass('show').attr('aria-hidden', 'true');
                siteHeader.removeClass('overlay-white has-overlay');
            }

            // Close menu if it's open
            if ($('#primaryNavigation').hasClass('show')) {
                $('#primaryNavigation').removeClass('show');
                menuClose.removeClass('show');
                headerContainer.removeClass('menu-expanded');
                $('#navbarToggle').attr('aria-expanded', 'false');
                siteHeader.removeClass('overlay-gray');
            }

            // Close any open dropdowns
            $('.nav-item').removeClass('show');
            subToggle.attr('aria-expanded', 'false').removeClass('show');
            menuClose.removeClass('show');

            if (window.innerWidth < 992) {
                subNav.slideUp(300).removeClass('show');
            } else {
                subNav.removeClass('show').css('display', '');
            }

            // Final check - if no dropdowns are open, remove gray overlay
            if ($('.nav-item.show').length === 0) {
                siteHeader.removeClass('overlay-gray');
            }
        }
    });

    function handleTabKey(e) {
        if (searchLink.hasClass('show')) {  // Only handle when search overlay is open
            const searchForm = $('.search-form');
            const focusableElements = searchForm.find('input, button').toArray();
            const firstFocusable = focusableElements[0];
            const lastFocusable = focusableElements[focusableElements.length - 1];

            // If pressing Tab and on the last element, go to first element
            if (!e.shiftKey && document.activeElement === lastFocusable) {
                e.preventDefault();
                firstFocusable.focus();
            }

            // If pressing Shift+Tab and on the first element, go to last element
            if (e.shiftKey && document.activeElement === firstFocusable) {
                e.preventDefault();
                lastFocusable.focus();
            }
        }
    }

    // Add the keydown event listener
    $(document).on('keydown', function(e) {
        if (e.keyCode === 9) { // Tab key
            handleTabKey(e);
        }
    });
});
